import React, {useEffect} from 'react';
import './index.css';

const Modal = ({ isOpen, onClose, children, containerClass }) => {

    useEffect(() => {
        if (isOpen) {
            document.body.classList.add("modal-open");
        }
        return () => {
            document.body.classList.remove('modal-open');
        };
    }, [isOpen])

    const onCloseFn = () => {
        document.body.classList.remove("modal-open");
        onClose();
    }

    return (
        <>
            {isOpen && (
                <>
                    <div className="modal-backdrop" onClick={onCloseFn} />
                    <div className="modal-container" onClick={onCloseFn}>
                        <div className="modal-inContainer">
                            <div className={`modal ${containerClass}`} onClick={(event) => {
                                event.stopPropagation();
                            }}>
                                <div className="modal-content">
                                    {children}
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            )}
        </>
    );
}

export default Modal;
